exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#Lenguaje:hover span.seMuestra[data-v-4d6780a0],.seEscondera[data-v-4d6780a0]{display:none}#Lenguaje:hover span.seEscondera[data-v-4d6780a0]{display:block}#Lenguaje[data-v-4d6780a0]{position:fixed;width:175px;display:block;bottom:50%;right:0;text-align:center;font-size:12px;background-color:#0b773d;color:#fff;padding:8px;z-index:500;cursor:pointer}@media only screen and (max-width:500px){#WCheckin[data-v-4d6780a0]{width:100px;font-size:12px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d6780a0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Lang.vue
// module id = 553
// module chunks = 2